<template>
  <div>
    <base-modal :showing="visible" @close="$emit('close')" @opened="onOpened">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">
              Edit Hak Akses
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Edit Hak
            </p>
          </div>
        </div>
      </div>
      <form
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
        @submit.prevent="onSave"
      >
        <base-input
          label="Nama Hak Akses"
          :shadow="false"
          fullwidth
          placeholder="Nama Hak Akses"
          type="text"
          v-model="form.name"
        />
        <base-input
          tag="textarea"
          rows="3"
          label="Deskripsi Hak Akses"
          :shadow="false"
          fullwidth
          placeholder="Deskripsi Hak Akses"
          type="text"
          v-model="form.description"
        />
        <base-input label="Tipe Office">
          <base-select
            :shadow="false"
            expand
            :options="[
              { key: 'null', value: null, label: 'Tipe Kantor' },
              { key: 'pusat', value: 'pusat', label: 'Pusat' },
              {
                key: 'kantor_pelayanan',
                value: 'kantor_pelayanan',
                label: 'Kantor Pelayanan',
              },
              {
                key: 'stockist_center',
                value: 'stockist_center',
                label: 'Stockist Center',
              },
              { key: 'stockist', value: 'stockist', label: 'Stockist' },
              { key: 'member', value: 'member', label: 'Mitra Usaha' },
            ]"
            v-model="form.office_type"
          />
        </base-input>
        <div class="space-x-2">
          <base-button color="white" type="button" @click="$emit('close')"
            >Batal</base-button
          >
          <base-button>Simpan</base-button>
        </div>
      </form>
    </base-modal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '@/components/base/BaseModal.vue';
import { mapActions } from 'vuex';

export default {
  mixins: [requestMixin],
  components: { BaseModal },
  props: {
    visible: Boolean,
    role: Object
  },
  emits: ['close', 'success'],
  data() {
    return {
      loading: false,
      form: {
        name: null,
        description: null,
        office_type: null
      },
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    onOpened() {
      this.form.name = this.role.attributes.name;
      this.form.description = this.role.attributes.description;
      this.form.office_type = this.role.attributes.office_type;
    },
    async onSave() {
      this.loading = true;

      const [, error] = await this.request(`/api/v1/roles/${this.role.id}`, {
        method: 'patch',
        data: {
          data: {
            type: 'roles',
            id: this.role.id,
            attributes: {
              name: this.form.name,
              description: this.form.description,
              office_type: this.form.office_type,
            },
          },
        },
      });

      if (!error) {
        this.$emit('success');
        this.$emit('close');
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.loading = false;
    },
  },
};
</script>
